export default "__VITE_ASSET__86df2228__"